module.exports = __webpack_public_path__ + "img/multiplier5_normal.99db827d.png";